// Offline support for POS (Kasir) — catalog cache + transaction queue

const KEY_Q = "pos_offline_txs";
const KEY_P = "pos_cache_products";
const KEY_C = "pos_cache_categories";
const KEY_S = "pos_settings";

const read = (k, fallback = null) => {
  try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : fallback; } catch { return fallback; }
};
const write = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch { /* ignore */ } };

// ---- Catalog cache ----
export const cacheCatalog = (products, categories) => {
  if (products) write(KEY_P, products);
  if (categories) write(KEY_C, categories);
};
export const cacheProductsOnly = (products) => write(KEY_P, products);
export const readCachedProducts = () => read(KEY_P, null);
export const readCachedCategories = () => read(KEY_C, []);

// ---- Settings cache (for receipt store name / footer) ----
export const cacheSettings = (s) => write(KEY_S, s);
export const readSettings = () => read(KEY_S, {});

// ---- Transaction queue ----
export const getQueue = () => read(KEY_Q, []);
const setQueue = (arr) => write(KEY_Q, arr);

export const tempInvoice = () => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  return `OFFLINE-${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}-${p(d.getHours())}${p(d.getMinutes())}${p(d.getSeconds())}`;
};

export const enqueueTx = (body) => {
  const q = getQueue();
  q.push({ id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, body, created_at: new Date().toISOString() });
  setQueue(q);
  return q.length;
};

const removeFromQueue = (id) => setQueue(getQueue().filter((x) => x.id !== id));

export const buildLocalTx = (body, cashier) => {
  const subtotal = body.items.reduce((s, it) => s + it.qty * it.price, 0);
  const total = Math.max(0, subtotal - (body.discount || 0));
  const paid = body.paid != null ? body.paid : total;
  return {
    id: null,
    offline: true,
    invoice_no: tempInvoice(),
    items: body.items,
    subtotal,
    discount: body.discount || 0,
    total,
    payment_type: body.payment_type,
    payments: body.payments,
    paid,
    change: Math.max(0, paid - total),
    cashier,
    created_at: new Date().toISOString(),
    note: body.note || null,
  };
};

// Keep failed transactions for retry; never silently discard a sale.
export const syncQueue = async (api) => {
  const q = getQueue();
  let ok = 0, fail = 0;
  for (const item of q) {
    try {
      await api.post("/transactions", { ...item.body, client_request_id: item.body.client_request_id || item.id });
      removeFromQueue(item.id);
      ok++;
    } catch (e) {
      fail++;
      if (e.response?.status === 401 || e.response?.status === 403) break;
    }
  }
  return { ok, fail };
};
